package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.data.ObraItem
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.launch

@Composable
fun SharedAdminObrasPanel(
    controller: AppController,
    onMessage: (String) -> Unit
) {
    var obras by remember { mutableStateOf<List<ObraItem>>(emptyList()) }
    var loading by remember { mutableStateOf(true) }
    var novoCodigo by remember { mutableStateOf("") }
    var novoNome by remember { mutableStateOf("") }
    var filtro by remember { mutableStateOf("") }
    var catalogoAberto by remember { mutableStateOf(false) }
    var editandoId by remember { mutableStateOf<String?>(null) }
    var editNome by remember { mutableStateOf("") }
    val scope = rememberCoroutineScope()

    fun recarregar() {
        scope.launch {
            loading = true
            AuthApi.listObrasAdmin()
                .onSuccess { obras = it.sortedWith(compareBy({ !it.ativo }, { it.sortOrder }, { it.nome })) }
                .onFailure { onMessage(it.message ?: "Falha ao listar obras") }
            loading = false
        }
    }

    LaunchedEffect(Unit) { recarregar() }

    val filtradas = remember(obras, filtro) {
        val q = filtro.trim()
        if (q.isEmpty()) obras
        else obras.filter { it.nome.contains(q, ignoreCase = true) }
    }

    val compactBtnPadding = PaddingValues(horizontal = 8.dp, vertical = 4.dp)

    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            Modifier.padding(horizontal = 8.dp, vertical = 6.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(Modifier.weight(1f)) {
                    Text(
                        "Catálogo de obras",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleSmall,
                        color = PortalCores.Navy
                    )
                    Text(
                        if (catalogoAberto) {
                            "Somente admin. Ativas no dropdown do formulário."
                        } else {
                            "Oculto. Toque em Abrir para gerenciar."
                        },
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                PortalOutlinedButton(
                    onClick = { catalogoAberto = !catalogoAberto },
                    contentPadding = compactBtnPadding
                ) {
                    Text(if (catalogoAberto) "Ocultar" else "Abrir", style = MaterialTheme.typography.labelLarge)
                }
            }

            if (!catalogoAberto) return@Column

            if (loading) {
                Text("Carregando…", style = MaterialTheme.typography.labelSmall)
            }

            Text(
                "Cadastre no padrão do SIENGE (sistema do financeiro): código numérico e o nome oficial do centro de custo. " +
                    "Ao salvar, o item entra no banco de obras e no banco de centros de custo.",
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(6.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                AppOutlinedTextField(
                    value = novoCodigo,
                    onValueChange = { novoCodigo = it.filter { ch -> ch.isDigit() }.take(10) },
                    placeholder = { Text("Código", style = MaterialTheme.typography.bodySmall) },
                    singleLine = true,
                    textStyle = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.width(110.dp),
                    colors = FormFieldDefaults.textFieldColors()
                )
                AppOutlinedTextField(
                    value = novoNome,
                    onValueChange = { novoNome = it },
                    placeholder = { Text("Nome oficial no SIENGE", style = MaterialTheme.typography.bodySmall) },
                    singleLine = true,
                    textStyle = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.weight(1f),
                    colors = FormFieldDefaults.textFieldColors()
                )
                PortalOutlinedButton(
                    onClick = {
                        val codigo = novoCodigo.trim()
                        val nome = novoNome.trim()
                        if (!codigo.all { it.isDigit() } || codigo.isEmpty() || nome.length < 3) {
                            onMessage("Cadastre no padrão do SIENGE: código numérico e o nome oficial do centro de custo.")
                            return@PortalOutlinedButton
                        }
                        scope.launch {
                            AuthApi.createObra("$codigo - $nome")
                                .onSuccess {
                                    novoCodigo = ""
                                    novoNome = ""
                                    onMessage("Obra $codigo - $nome gravada no cadastro de obras e de centros de custo.")
                                    recarregar()
                                    controller.carregarObrasAtivas()
                                }
                                .onFailure { onMessage(it.message ?: "Falha ao adicionar obra") }
                        }
                    },
                    enabled = novoCodigo.isNotBlank() && novoNome.isNotBlank(),
                    contentPadding = compactBtnPadding
                ) { Text("Adicionar", style = MaterialTheme.typography.labelLarge) }
            }

            if (obras.size > 5) {
                AppOutlinedTextField(
                    value = filtro,
                    onValueChange = { filtro = it },
                    placeholder = { Text("Buscar obra", style = MaterialTheme.typography.bodySmall) },
                    singleLine = true,
                    textStyle = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.fillMaxWidth(),
                    colors = FormFieldDefaults.textFieldColors()
                )
            }

            filtradas.forEachIndexed { index, obra ->
                if (index > 0) {
                    HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                }
                val emEdicao = editandoId == obra.id
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 2.dp),
                    horizontalArrangement = Arrangement.spacedBy(4.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (emEdicao) {
                        AppOutlinedTextField(
                            value = editNome,
                            onValueChange = { editNome = it },
                            placeholder = { Text("Nome", style = MaterialTheme.typography.bodySmall) },
                            singleLine = true,
                            textStyle = MaterialTheme.typography.bodySmall,
                            modifier = Modifier.weight(1f),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        TextButton(
                            onClick = {
                                val nome = editNome.trim()
                                if (nome.length < 2) {
                                    onMessage("Nome da obra inválido.")
                                    return@TextButton
                                }
                                scope.launch {
                                    AuthApi.updateObra(obra.id, nome = nome)
                                        .onSuccess {
                                            editandoId = null
                                            editNome = ""
                                            onMessage("Nome atualizado.")
                                            recarregar()
                                            controller.carregarObrasAtivas()
                                        }
                                        .onFailure {
                                            onMessage(it.message ?: "Falha ao renomear obra")
                                        }
                                }
                            },
                            contentPadding = compactBtnPadding
                        ) { Text("Salvar", style = MaterialTheme.typography.labelMedium) }
                        TextButton(
                            onClick = {
                                editandoId = null
                                editNome = ""
                            },
                            contentPadding = compactBtnPadding
                        ) { Text("Cancelar", style = MaterialTheme.typography.labelMedium) }
                    } else {
                        Text(
                            obra.nome,
                            modifier = Modifier.weight(1f),
                            style = MaterialTheme.typography.bodySmall,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        TextButton(
                            onClick = {
                                editandoId = obra.id
                                editNome = obra.nome
                            },
                            contentPadding = compactBtnPadding
                        ) { Text("Editar", style = MaterialTheme.typography.labelMedium) }
                    }
                    Text(
                        if (obra.ativo) "Ativa" else "Inativa",
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    Switch(
                        checked = obra.ativo,
                        onCheckedChange = { ativo ->
                            scope.launch {
                                AuthApi.updateObra(obra.id, ativo = ativo)
                                    .onSuccess {
                                        recarregar()
                                        controller.carregarObrasAtivas()
                                    }
                                    .onFailure {
                                        onMessage(it.message ?: "Falha ao atualizar obra")
                                    }
                            }
                        }
                    )
                }
            }

            if (!loading && filtradas.isEmpty()) {
                Text(
                    if (filtro.isNotBlank()) "Nenhuma obra encontrada." else "Nenhuma obra cadastrada.",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
        }
    }
}
